import { Card } from "antd";

const MerchantSettings = () => {
    return (
        <Card style={{marginTop:10}}>
            <h1>Merchant Settings</h1>
        </Card>
    );
}
export default MerchantSettings;